module.exports = __webpack_public_path__ + "static/media/icon_analytics_gray.2411f241.png";